import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import info from '../../api/info';
import {
  convertor,
  filterSelectedTickets,
  copyTickets,
  calTotalPrice,
  filterSubmitTickets,
} from '../../setup/convertor';
import Vue from 'vue';
import filter from '../../setup/lkFilter';
const state = {
  ticketConfigInfo: null,
  contanctList: {},
  totalPriceShow: '0',
  isLogin: false,
};
const actions = {
  async getTicketConfigInfo({ commit }, params) {
    if (state.ticketConfigInfo == null) {
      const ticketInfoEx = await info.getTicketInfoEx(params);
      commit('allTicketConfigInfo', ticketInfoEx);
    }
  },
  updateContactInfoGet({ commit }, params) {
    commit('updateContactInfo', params);
  },
};
const getters = {
  isLogin: function(state) {
    return state.isLogin;
  },
  ticketInfo: function(state) {
    return state.ticketConfigInfo;
  },
  allContanctInfo: function(state) {
    console.log('联系人数据是', JSON.stringify(state.contanctList));
    let tickets = filterSelectedTickets(copyTickets(state.contanctList));
    return tickets;
  },
  totalPrice(state) {
    return state.totalPriceShow;
  },
  allSubmitTickets(state) {
    let submitTickets = filterSubmitTickets(copyTickets(state.contanctList));
    console.log('组装的订单信息', submitTickets);
    return submitTickets;
  },
};

const mutations = {
  upDataLogin(state, isOrLogin) {
    state.isLogin = isOrLogin;
  },
  allTicketConfigInfo(state, ticketConfigInfo) {
    state.ticketConfigInfo = convertor(ticketConfigInfo); //组装数据格式
  },
  updateContactInfo(state, contanctListGet) {
    for (let i = 0; i < contanctListGet.length; i++) {
      let ticket = contanctListGet[i];
      Vue.set(state.contanctList, ticket.key, ticket);
    }
    let getTotalPrice = calTotalPrice(state.contanctList);
    state.totalPriceShow = filter.toYuan(getTotalPrice * 100, 2);
  },
  delecteContact(state, ticket) {
    if (ticket == null) {
      state.contanctList = {};
      state.totalPriceShow = '0';
      return;
    }
    let tmp = state.contanctList;
    if (Object.prototype.hasOwnProperty.call(tmp, ticket.key)) {
      let userTicket = tmp[ticket.key];
      let oldTickets = userTicket.tickets;
      let i = -1;
      for (let j = 0; j < oldTickets.length; j++) {
        let ticketInfo = oldTickets[j];
        if (ticketInfo.ticket_type == ticket.code) {
          i = j;
          break;
        }
      }
      if (i > -1) {
        oldTickets.splice(i, 1);
        if (oldTickets.length == 0) {
          delete tmp[ticket.key];
        } else {
          tmp[ticket.key] = userTicket;
        }
      }
    }
    state.contanctList = tmp;
    let getTotalPrice = calTotalPrice(state.contanctList);
    state.totalPriceShow = filter.toYuan(getTotalPrice * 100, 2);
  },
};
export default {
  state,
  actions,
  getters,
  mutations,
};
